import React from 'react';

function FeaturesSection() {
  return (
    <div className="container-xxl py-5">
      <div className="container">
        <div className="row g-5">
          <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.1s">
            <h1 className="display-6 mb-5">Por que elegirnos</h1>
            <p className="mb-5" style={{textAlign: 'justify'}}>En TAMASERVICE, entendemos que el control del clima es fundamental para el confort, la productividad y la integridad de tus procesos. Por eso, nos especializamos en el diseño e instalación de sistemas de climatización de alto rendimiento, abarcando desde soluciones para el hogar y pequeñas empresas hasta proyectos complejos de climatización industrial. Confía en nuestro equipo de técnicos certificados para garantizar un ambiente perfecto, eficiente y duradero</p>
            <div className="d-flex mb-5">
              <div className="flex-shrink-0 btn-square bg-primary rounded-circle" style={{width: '90px', height: '90px'}}>
                <img className="img-fluid" src="/img/icon/icon-08-light.png" alt="" />
              </div>
              <div className="ms-4">
                <h5 className="mb-3">Asesoramiento Personalizado</h5>
                <span style={{textAlign: 'justify'}}>Te ayudamos a elegir el sistema ideal que maximice la eficiencia energética y se ajuste a tu presupuesto.</span>
              </div>
            </div>
            <div className="d-flex mb-5">
              <div className="flex-shrink-0 btn-square bg-primary rounded-circle" style={{width: '90px', height: '90px'}}>
                <img className="img-fluid" src="/img/icon/icon-10-light.png" alt="" />
              </div>
              <div className="ms-4">
                <h5 className="mb-3">Marcas de Líderes</h5>
                <span style={{textAlign: 'justify'}}>rabajamos con las mejores marcas del mercado para ofrecerte equipos fiables, silenciosos y con la última tecnología.</span>
              </div>
            </div>
            <div className="d-flex mb-0">
              <div className="flex-shrink-0 btn-square bg-primary rounded-circle" style={{width: '90px', height: '90px'}}>
                <img className="img-fluid" src="/img/icon/icon-06-light.png" alt="" />
              </div>
              <div className="ms-4">
                <h5 className="mb-3">Ingeniería a Medida</h5>
                <span style={{textAlign: 'justify'}}>Analizamos tus requerimientos específicos (temperatura, humedad, ventilación) para diseñar un sistema que garantice la estabilidad de tus procesos.</span>
              </div>
            </div>
            
          </div>
          <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.5s">
            <div className="position-relative rounded overflow-hidden h-100" style={{minHeight: '400px'}}>
              <img className="position-absolute w-100 h-100" src="/img/imagenPrincipal.jpeg" alt="" style={{objectFit: 'cover'}} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FeaturesSection;